<h1>Terms and Conditions</h1>
<p>High Tech District (registered as HIGHTECHDISTRICT.COM LIMITED) operates this website. All references to 'we,' 'us,' and 'our' refer to High Tech District.</p>
<p>We are not liable for any direct, indirect, incidental, or consequential losses arising from your use of our website or web application. By using our platform, you acknowledge and accept that your use is at your own risk.</p>

<h2>XP Points and Rewards Disclaimer</h2>

<p>
  XP points on the High Tech District platform are designed to encourage learning,
  participation, and progress tracking. XP points currently do not hold any monetary value
  and cannot be exchanged for cash, goods, or services.
</p>

<p>
  We may, in the future, introduce optional prize draws or promotional rewards
  (such as gift cards) based on XP points. These features, if and when introduced, will be
  governed by additional terms and eligibility criteria.
</p>

<p>
  Users can only redeem or earn XP points <strong>once per eligible question or activity</strong>,
  even if repeated. The awarding of XP points is at our sole discretion and may be subject to
  verification.
</p>

<p>
  We reserve the right to modify, suspend, or discontinue the XP points system or any associated
  rewards at any time without prior notice.
</p>

<h2>Intellectual Property</h2>

<p>
  All content, features, and functionality on the High Tech District platform — including but not limited to
  text, code, exercises, graphics, logos, software, designs, AI-generated features, and interactive elements —
  are the exclusive property of High Tech District (HIGHTECHDISTRICT.COM LIMITED) unless otherwise stated.
</p>

<p>
  Users may not copy, reproduce, modify, republish, upload, post, transmit, or distribute any part of the
  platform's content or code without prior written permission from High Tech District.
</p>

<p>
  Any content submitted by users (such as code, comments, or project contributions) remains their intellectual property,
  but by submitting it to the platform, users grant High Tech District a non-exclusive, royalty-free, worldwide license
  to use, display, reproduce, and distribute that content for educational and promotional purposes within the platform.
</p>

<p>
  Unauthorized use of any materials on the platform may violate copyright, trademark, and other applicable laws
  and may result in legal action.
</p>

<h2>Contributors, Employees, and Collaborators</h2>

<p>
  Specific terms may apply to users who contribute educational content, work with High Tech District as part of an internship, employment agreement, university collaboration, or commercial contract. These terms will be outlined in separate written agreements between High Tech District and the contributor, and will override any conflicting clauses in these general Terms and Conditions.
</p>

<div *ngIf="isAcceptDeclineButton">
  <button class="btn btn-primary m-1" (click)="accept()">Accept</button>

  <button class="btn btn-danger m-1" (click)="decline()">Decline</button>
</div>
<div *ngIf="!isAcceptDeclineButton">
  <button class="btn btn-primary m-1" (click)="accept()">Close</button>
</div>
